<template>
  <div :class="[`content`, `content__home`]">
    <video-background :sources="videoSources" />
    <div class="cta">
      <span class="logo" />

      <div class="cta__buttons">
        <router-link
          v-for="(path, index) in chapterPaths"
          :key="index"
          :to="path.url"
          class="cta__button"
        >
          {{ path.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import VideoBackground from '@/components/VideoBackground'

export default {
  name: 'view-home',

  // Data
  data () {
    return {
      transitioning: false,
      videoSources: [
        require('@/assets/video/background.mov'),
        require('@/assets/video/background.mp4')
      ],
      chapterPaths: [
        {
          url: `/page/ch1/`,
          label: `CH. 1 Foreward`
        },
        {
          url: `/page/ch2/`,
          label: `CH. 2 Micro Trends`
        },
        {
          url: `/page/ch3/`,
          label: `CH. 3 Macro Trends`
        }
      ]
    }
  },

  components: {
    VideoBackground
  },

  // Methods
  methods: {
    ...mapActions(`header`, [`toggleHeader`]),
    ...mapActions(`navigation`, [`toggleNavigation`]),
    ...mapActions(`sidebar`, [`toggleSidebar`]),

    startPresentation () {
      this.$router.push({
        name: `page`
      })
    }
  },

  // Watchers

  // Lifecycles
  created () {
    this.toggleHeader(false)
    this.toggleNavigation(false)
    this.toggleSidebar(false)
  }
}
</script>
